import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { PmsComponent } from './pms.component';
import { CatalogComponent } from './catalog/catalog.component';
import { UbsViewContainersModule, ViewContainersService } from '@urbannex/view-containers';
import { NbMenuItem } from '@nebular/theme';
import { CategoriesComponent } from './categories/categories.component';
import { ProductsComponent } from './products/products.component';
import { ConfigurationsComponent } from './configurations/configurations.component';
import { FeaturesComponent } from './features/features.component';
import { ImageManagementComponent } from './image-management/image-management.component';
import { StoresComponent } from './stores/stores.component';
import { ShippingComponent } from './shipping/shipping.component';

export const routes:Routes = [
  {
    path:'',
    component:PmsComponent,
  },
  {
    path:'stores',
    component:StoresComponent
  },
  {
    path:'catalog',
    component:CatalogComponent,
  },
  {
    path:'categories',
    component:CategoriesComponent,
  },
  {
    path:'categories/:id',
    component:CategoriesComponent,
  },
  {
    path:'categories/:prodCatalogCategoryId/category/:productCategoryId',
    component:CategoriesComponent,
  },
  /* {
    path:'products',
    component:ProductsComponent,
  }, */
  {
    path:'products/:productCategoryId/product/:productId',
    component:ProductsComponent,
  },
  {
    path:'configurations',
    component:ConfigurationsComponent
  },
  {
    path:'features',
    component:FeaturesComponent
  },
  {
    path:'image-management',
    component:ImageManagementComponent
  },
  {
    path:'shipping',
    component:ShippingComponent
  },
  { path: 'marketing', loadChildren: () => import('./marketing/marketing.module').then(m => m.MarketingModule) }
];

const MENU_ITEMS:NbMenuItem[] = [
  {
    title: 'Stores',
    icon: 'cube-outline',
    link: '/admin/pms/stores',
  },
  {
    title: 'Catalog',
    icon: 'globe-outline',
    link: '/admin/pms/catalog',
  },
  {
    title: 'Categories',
    icon: 'file-text-outline',
    link: '/admin/pms/categories',
  },
  {
    title: 'Configurations',
    icon: 'clipboard-outline',
    link: '/admin/pms/configurations',
  },
  {
    title: 'Features',
    icon: 'book-outline',
    link: '/admin/pms/features',
  },
  {
    title: 'Image Management',
    icon: 'people-outline',
    link: '/admin/pms/image-management',
  },
  {
    title: 'Price Rules',
    icon: 'cube-outline',
    link: '/admin/pms/price-rules',
  },
  {
    title: 'Product Store Groups',
    icon: 'color-palette-outline',
    link: '/admin/pms/product-store-groups',
  },
  {
    title: 'Products',
    icon: 'book-outline',
    link: '/admin/pms/products',
  },
  {
    title: 'Promos',
    icon: 'people-outline',
    link: '/admin/pms/promos',
  },
  {
    title: 'Reviews',
    icon: 'cube-outline',
    link: '/admin/pms/reviews',
  },
  {
    title: 'Shipping',
    icon: 'color-palette-outline',
    link: '/admin/pms/shipping',
  },
  {
    title: 'Thesaurus',
    icon: 'color-palette-outline',
    link: '/admin/pms/thesaurus',
  },
];
const headerTitle:string = "PMS";
const menuTag = "pmsMenu";


@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    UbsViewContainersModule
  ],
  exports:[RouterModule,UbsViewContainersModule]
})
export class PmsRoutingModule {
  menuAndTitleOptions = {path:"pms",menuItems:MENU_ITEMS,headerTitle:headerTitle,menuTag:menuTag}; 
  constructor(private viewContainerService:ViewContainersService){
    this.viewContainerService.menuAndTitleOptions$.next([... this.viewContainerService.menuAndTitleOptions$.getValue(),this.menuAndTitleOptions]);
    this.viewContainerService.activeMenuTag$.next(menuTag);
    //this.viewContainerService.addMenuAndTitleOptions(menuAndTitleOptions)    

  }
}
